<template lang="pug">

  //- div(cycle light touchless hide-delimiters :show-arrows="false" :height="150" :interval="5000")

    div(v-for="(item, index) in slides" :key="index" to="/admin/assinatura")

      div(class="fill-height" align="center" justify="center")
        .text-h2
          img(:src="item.img").img-banner

  v-carousel(cycle light touchless hide-delimiters :show-arrows="false" :height="150" :interval="5000")

    v-carousel-item(v-for="(item, index) in slides" :key="index" to="/admin/assinatura")

      v-row(class="fill-height" align="center" justify="center")
        .text-h2
          img(:src="item.img").img-banner

</template>

<script>
  import anuncio1 from './anuncios/anuncio1.jpg'
  import anuncio2 from './anuncios/vantagens-premium.jpeg'
  // import anuncio2 from './anuncios/anuncio2.jpg'
  import anuncio3 from './anuncios/anuncio3.jpg'
  // import anuncio4 from './anuncios/anuncio4.jpg'

  export default {
    name: 'Banner',
    data: () => ({
      slides: [
        {
          img: anuncio1,
        },
        {
          img: anuncio2,
        },
        {
          img: anuncio3,
        },
        {
          img: anuncio2,
        },
      ],
    }),
  }
</script>
<style lang="scss" scoped>

  .img-banner {
    width: 100%;
  }

</style>
